import { observer } from 'mobx-react-lite'
import { Text, View } from 'react-native'

import { Player } from '@ppwr/poker'

import { BaseModalConfig } from '../'
import ChipsIcon from '../../../assets/Chips.svg'
import { styles } from './AllIn.style'

export interface AllInProps extends BaseModalConfig {
  player?: Player
}

export const AllIn = observer(({ player }: AllInProps) => {
  if (!player) return null
  return (
    <View style={styles.container}>
      <View style={styles.chipContainer}>
        <ChipsIcon height={32} width={32} />
        <Text style={styles.chipText}>{player.chips}</Text>
      </View>
      <View style={styles.winnerContainer}>
        <Text style={styles.winnerText}>{player.chips} is all in!</Text>
      </View>
    </View>
  )
})
